import debounce from '../../../helpers/debounce.js'

export const detectScroll = () => {
	const detectScrollFn = () => document.body.classList[window.pageYOffset > 54 ? 'add' : 'remove']('page-scroll')
	window.addEventListener('scroll', debounce(() => document.body.classList[window.pageYOffset > 54 ? 'add' : 'remove']('page-scroll'), 50));
	detectScrollFn();
}
